export default [
  {
    path: '/real-estate-developments-settings/reference-points',
    name: 'ReferencePointsList',
    component: () => import('pages/real-estate-developments-settings/reference-points/ReferencePointsList.vue')
  },
  {
    path: '/real-estate-developments-settings/reference-points/new',
    name: 'ReferencePointsCreate',
    component: () => import('pages/real-estate-developments-settings/reference-points/ReferencePointsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/reference-points/:id/edit',
    name: 'ReferencePointsEdit',
    component: () => import('pages/real-estate-developments-settings/reference-points/ReferencePointsForm.vue')
  },
  {
    path: '/real-estate-developments-settings/reference-points/:id',
    name: 'ReferencePointsSingle',
    component: () => import('pages/real-estate-developments-settings/reference-points/ReferencePointsSingle.vue')
  }
]
